import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import PropTypes from "prop-types";

function ViqeoEmbedBase(props) {
  const getEmbedCode = (lang, viqeoEmbed) => {
    var style = {
      width: "100%",
      height: 0,
      position: "relative"
    };

    if (lang === "en" && viqeoEmbed) {
      return (
        <div>
          <script async src="https://cdn.viqeo.tv/js/vq_starter.js" />
          <div style={style} className="viqeo-embed" data-playerId="305" data-profile="1076">
            <iframe
              src="https://cdn.viqeo.tv/embed?playerId=305"
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>
      );
    } else if (lang === "ur" && viqeoEmbed) {
      return (
        <div>
          <script async src="https://cdn.viqeo.tv/js/vq_starter.js" />
          <div style={style} className="viqeo-embed" data-playerId="307" data-profile="1080">
            <iframe
              src="https://cdn.viqeo.tv/embed?playerId=307"
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>
      );
    } else if (lang === "hi" && viqeoEmbed) {
      return (
        <div>
          <script async src="https://cdn.viqeo.tv/js/vq_starter.js" />
          <div style={style} className="viqeo-embed" data-playerId="306" data-profile="1078">
            <iframe
              src="https://cdn.viqeo.tv/embed?playerId=306"
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>
      );
    }
  };
  return (
    <React.Fragment>
      {getEmbedCode(props.publisherAttributes.lang, props.publisherAttributes.viqeo_embed)}
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
}

export const ViqeoEmbed = connect(
  mapStateToProps,
  null
)(ViqeoEmbedBase);

ViqeoEmbedBase.propTypes = {
  publisherAttributes: PropTypes.object
};
